import { useHasQumuConsent } from 'components/discover/video/hooks';
import { FC } from 'react';
import { styled } from 'styled-components';

interface VideoPlayerProps {
  videoId: string;
  className?: string;
}

const StyledIframe = styled.iframe`
  aspect-ratio: 16 / 9;
`;

export const VideoPlayer: FC<VideoPlayerProps> = ({ videoId, className }) => {
  const hasConsented = useHasQumuConsent();
  const videoUrl = `https://socgen.qumucloud.com/view/${videoId}?inline=true&autoPlay=true&embed=true&consented=${hasConsented}`;

  return (
    <StyledIframe allow="fullscreen" allowFullScreen className={className} title="SGME SP / Video" src={videoUrl}>
      Your browser must support iframes to play this content.
    </StyledIframe>
  );
};
